import { createTheme } from '@mui/material/styles';
import { red, green, yellow, amber, purple } from '@mui/material/colors';

// A theme with custom primary and secondary color.
// It's optional.
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: red['A200'],
      dark: red['700']
    },
    secondary: {
      main: green['A400'],
      withAlpha: 'rgb(0,230,118,0.08)',
    },
    highlight: {
      green: green['A100'],
      yellow: yellow['100'],
      red: red['100'],
    },
    tint: {
      success: green[700],
      fail: red[700],
    },
    warning: {
      main: yellow[700],
    },
    banner: {
      info: amber[200],
    },
    exportTag: {
      free: yellow['A700'],
      test: purple['A100'],
    },
    background: {
      default: '#202124',
      paper: '#313235',
      paperLight: 'rgba(255,255,255,0.08)',
      paperDark: 'rgba(0,0,0,0.16)',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1536,
    },
  },
  shape: {
    borderRadius: 6,
  },
  drawer: {
    width: 200,
  },
  videoDrawer: {
    width: 300,
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '13px',
          backgroundColor: 'rgba(32, 33, 36, 0.95)',
        },
        arrow: {
          color: 'rgba(32, 33, 36, 0.95)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            transitionDelay: '9999s',
            transitionProperty: 'background-color, color',
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'text' },
          style: {
            color: 'white',
            '&:hover': {
              textDecoration: 'none',
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
          },
        },
      ],
      styleOverrides: {
        outlined: {
          background: 'rgba(0, 0, 0, 0.2)',
        },
        containedPrimary: {
          color: '#fff',
          backgroundColor: red['700'],
          '&:hover': {
            backgroundColor: '#932020',
          },
        },
        containedSecondary: {
          color: '#fff',
          backgroundColor: green['700'],
          '&:hover': {
            backgroundColor: green['900'],
          },
        },
        outlinedInherit: {
          border: '1px solid rgba(255, 255, 255, 0.23)',
          '&:hover': {
            textDecoration: "none",
            backgroundColor: " rgba(255, 255, 255, 0.08)"
          }
        },
        sizeSmall: {
          height: 32,
        }
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        rounded: {
          border: '1px solid rgba(255, 255, 255, 0.12)',
          borderActive: 'rgba(255, 255, 255, 0.5)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          '&:hover': {
            border: '1px solid rgba(255, 255, 255, 0.5)',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          transition: 'opacity 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          '&:hover': {
            opacity: 0.7,
          },
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        'spacing-xs-1': {
          margin: 0,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: '500',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        dense: {
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    MuiListItemButton: {
        styleOverrides: {
            root:{
                paddingTop: 8,
                paddingBottom: 8,
                '&.Mui-selected': { backgroundColor: " rgba(255, 255, 255, 0.16)" },
                "&.Mui-selected:hover": { backgroundColor: "rgba(255, 255, 255, 0.16)" }
            }
        }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": { backgroundColor: "rgba(255, 255, 255, 0.16)" },
          "&.Mui-selected:hover": { backgroundColor: "rgba(255, 255, 255, 0.16)" },
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.08)" },
        }
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          '&.MuiButtonGroup-middleButton, &.MuiButtonGroup-firstButton': {
            borderColor: 'rgba(255, 255, 255, 0.23)',
          },
        }
      }
    }
  },
});

export default theme;